import type {
  NotificationSetting,
  NotificationPreview,
} from "../types/types";

/**
 * F018 期限通知（通知設定）API ユーティリティ。
 * 詳細: docs/design/F018_deadline-notification.md
 */

// サーバーは 400 / 403 で { message } を返すため、あればそれをエラー文言に使う
async function toError(res: Response, fallback: string): Promise<Error> {
  try {
    const body = (await res.json()) as { message?: unknown };
    if (typeof body.message === "string" && body.message) {
      return new Error(body.message);
    }
  } catch {
    // JSON でないレスポンスは既定の文言にする
  }
  return new Error(`${fallback} (${res.status})`);
}

const buildQuery = (roomId: number, honbuId: number) =>
  `roomId=${roomId}&honbuId=${honbuId}`;

export async function fetchNotificationSetting(
  roomId: number,
  honbuId: number,
): Promise<NotificationSetting> {
  const res = await fetch(
    `/api/notification-settings?${buildQuery(roomId, honbuId)}`,
  );
  if (!res.ok) throw await toError(res, "通知設定の取得に失敗しました");
  return res.json();
}

export async function saveNotificationSetting(
  roomId: number,
  honbuId: number,
  setting: NotificationSetting,
): Promise<NotificationSetting> {
  const res = await fetch(
    `/api/notification-settings?${buildQuery(roomId, honbuId)}`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(setting),
    },
  );
  if (!res.ok) throw await toError(res, "通知設定の保存に失敗しました");
  return res.json();
}

/** 保存前の設定で、今日送られる通知内容を取得する（送信はされない） */
export async function previewNotification(
  roomId: number,
  honbuId: number,
  setting: NotificationSetting,
): Promise<NotificationPreview> {
  const res = await fetch(
    `/api/notification-settings/preview?${buildQuery(roomId, honbuId)}`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(setting),
    },
  );
  if (!res.ok) throw await toError(res, "通知内容の確認に失敗しました");
  return res.json();
}
